import { parseQuery } from '../utils/mUtil'

const prototypes = {
  $ecReport(type: string, params?: any) {
    try {
      window.ecReport(type, Object.assign({}, getLobParamToReport(), params))
    } catch (error) {
      console.log(error)
    }
  },
  $ecShow(dom: Element, params?: any) {
    try {
      window.ecShow(dom, Object.assign({}, getLobParamToReport(), params))
    } catch (error) {
      console.log(error)
    }
  },
}

function getLobParamToReport() {
  const win = window as any
  const { goodReportData = {}, deviceInfo = {} } = win
  const attrs = goodReportData.attrs || {}
  return {
    $url: location.href,
    goods_id: goodReportData.goods_id && goodReportData.goods_id.toString(),
    // goods_num: attrs.goods_num,
    // shop_price: attrs.price || '',
    // spec1: attrs.spec1,
    // spec2: attrs.spec2,
    // store_id: goodReportData.store_id && goodReportData.store_id.toString(),
    ref_page_name: parseQuery().refPageName || '',
    $event_type: 'track',
    $project: 'mgtv-ec',
    $network_type: deviceInfo?.network_type,
    sessionid: window?.deviceInfo?.sessionid ?? '',
  }
}

export default prototypes
